import React from "react";
import { useEffect } from "react";
import PageTitle from "../../shared/PageTitle";
import { useLocation } from "react-router-dom";
import { BlankString, MenuId } from "../../Constants";
import { useNavigate } from "react-router-dom";

const RegistrationSuccess = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const pageName: string = "Registration Success";

  useEffect(() => {
    if (state === null) navigate("/");
    window.history.replaceState({}, document.title);
  });

  return (
    <>
      <PageTitle title={pageName} />
      <div className="container gp-container">
        <div className="row">
          <div className="col-md-6">
            {
              (state !== null && state.registrationSuccess === true) ?
                <div className="alert alert-success" role="alert">
                  <h3><strong>Welcome to GPFA!!!</strong></h3>
                  <br/>
                  <p className="free-text">We are thrilled to welcome you to GPFA Agent Portal! Your skills, experience, and unique perspective and valuable assets that we are excited to have on board.</p>
                  <p className="free-text">Your registration with GPFA is completed, Once your signed contract is reviewed and approved please expect an email from portal and then you can login. We are here to support you. </p>
                  <p className="free-text">If you have any questions or concerns, please contact support group via email at aportal@gpfalliance.com </p>
                  <h4>Thankyou, <br/> GPFA</h4>
                </div>
              :
              BlankString
            }
          </div>
        </div>
      </div>
    </>
  );
};
export default RegistrationSuccess;